import { Link } from 'react-router-dom';
import SiteHeader from './shared/SiteHeader';
import { usePageMeta } from '../lib/usePageMeta';

export default function Terminos() {
  usePageMeta('Términos y condiciones | LABPSI');
  return (
    <div className="page-terminos">
      <div className="navbar-wrapper">
        <SiteHeader minimal />
      </div>

      <div className="terms-container">
        <div className="terms-section">
          <h1 className="terms-title">TÉRMINOS Y CONDICIONES - POLÍTICAS DE PRIVACIDAD</h1>

          <hr className="terms-hr" />

          <p>
            Este sitio utiliza el servicio de Google Analytics para medir el funcionamiento técnico y la frecuencia de uso de la página web en general. Los datos recolectados (como ciudad de conexión, tipo de dispositivo y fuente de tráfico) son tratados de forma agregada y anonimizada. Los creadores del sitio no recopilan datos personales identificables, no registran las direcciones IP de los usuarios ni almacenan las respuestas individuales a los ejercicios.
          </p>
          <p>
            Los ejercicios y materiales contenidos en este sitio tienen como objetivo la estimulación cognitiva y no constituyen, bajo ninguna circunstancia, un diagnóstico médico, tratamiento clínico ni sustituyen la consulta con un profesional de la salud calificado. El uso del sitio es responsabilidad exclusiva del usuario.
          </p>
        </div>

        <hr className="terms-hr" />

        <div className="terms-footer">
          <p>
            Contacto:{' '}
            <a href="mailto:labpsi@mdp.edu.ar">labpsi@mdp.edu.ar</a>
          </p>
          <Link to="/" className="terms-back-home">
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
